export default "__VITE_ASSET__BLz3K6IG__"